import { render, staticRenderFns } from "./ClassroomIcon.vue?vue&type=template&id=fe7f293c"
import script from "./ClassroomIcon.vue?vue&type=script&lang=js"
export * from "./ClassroomIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports